export { default as IndexTableEmptyCell } from './IndexTableEmptyCell';
